import React, { ReactElement } from 'react';
import { IKountDetailsProps } from '../../containers/types/BillingPaymentContainer';

interface KountLogoProps {
  details: IKountDetailsProps;
}

const KountLogo = ({ details }: KountLogoProps): ReactElement | null => {
  if (!details.kConfig?.enabled) {
    return null;
  }

  const kountParams = `?m=${details.kConfig.merchant_id}&s=${details?.kUserIdentifier}`;
  const iFrameSrc = (details: { kConfig: { htm_url: string } }) => `${details.kConfig.htm_url}${kountParams}`;
  const imgSrc = (details: { kConfig: { gif_url: string } }) => `${details.kConfig.gif_url}${kountParams}`;

  return (
    <iframe id="kountframe" style={{ display: 'none' }} src={iFrameSrc(details)}>
      <img src={imgSrc(details)} />
    </iframe>
  );
};

export default KountLogo;
